import { render, staticRenderFns } from "./spare-part-replacement.vue?vue&type=template&id=481ae1c9&"
import script from "./spare-part-replacement.vue?vue&type=script&lang=js&"
export * from "./spare-part-replacement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports